import {post} from './../../../utils/request';
import {OAUTH_URL, USER_BIND_PHONE, USER_LOGIN, USER_REGISTER, USER_SMS_CODE,USER_ACCESS_loginToken} from '../../../utils/api';

export const wxLogin = (params) => {
    return async () => {
        const result = await post(USER_LOGIN, params);
        return result;
    }
}

export const getAuthUrl = (params) => {
    return async () => {
        const result = await post(OAUTH_URL, params);
        return result;
    }
}


export const isRegister = (params) => {
    return async (dispatch) => {
        const result = await post(USER_REGISTER, params);
        return result;
    }
}

export const sendMessageActionResult = (params) => {
    return async (dispatch) => {
        const result = await post(USER_SMS_CODE, params);
        return result;
    }
}

export const bindPhoneActionResult = (params) => {
    return async (dispatch) => {
        const result = await post(USER_BIND_PHONE, params);
        return result;
    }
}


export const getOauthInfo = (params) => {
    return async () => {
        const result = await post(USER_ACCESS_loginToken, params);
        return result;
    }
}